$(function() {
	$('.ff-textarea textarea').on('blur input', function() {
		$(this).addClass('touched');
	});
});